import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';
import { from, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PlatformEnum } from '@sifca-monorepo/widget-generator';
import { MobileVersionService } from '@sifca-monorepo/clients';

@Injectable({ providedIn: 'root' })
export class VersionGuard implements CanActivate {
  private checked = false;
  private blocked = false;

  constructor(
    private router: Router,
    private platform: Platform,
    private versionService: MobileVersionService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (this.checked) {
      return of(this.blocked ? this.router.createUrlTree(['/update']) : true);
    }

    const platformEnum = this.platform.is('ios') ? PlatformEnum.IOS : PlatformEnum.ANDROID;
    return from(App.getInfo()).pipe(
      map((info) => info.version),
      catchError(() => of(null)),
      switchMap((appVersion) =>
        this.versionService.getLastVersionByPlatformAndTarget(platformEnum).pipe(
          map((version) => {
            this.checked = true;

            if (version?.requireUpdate && version.version !== appVersion) {
              this.blocked = true;
              return this.router.createUrlTree(['/update']);
            }

            return true;
          }),
          catchError(() => {
            this.checked = true;
            return of(true as boolean | UrlTree);
          }),
        ),
      ),
    );
  }
}
